import { Path, Rect, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M12 20V4" />
		<Rect x="4" y="9" width="16" height="6" fill="currentColor" stroke="none" />
	</SVG>
);
